import { ProjectRoleType } from '@platform/client/schemas';
import { Button, PillBadge } from '@platform/components';
import { DisplayDataForRoleType } from '../util';

export const ProjectCard = ({
  projectName,
  projectType,
  tags,
  projectId,
}: {
  projectName: string;
  projectType: ProjectRoleType;
  tags: string[];
  projectId: string;
}) => {
  return (
    <div className='border border-gray-100 rounded-xl p-4 flex flex-col gap-4'>
      <div className='flex items-start grow'>
        <div className='flex items-center gap-2'>
          <div className='w-14 h-14'>{DisplayDataForRoleType[projectType].icon()}</div>
          <div className='flex flex-col'>
            <div className='text-base text-gray-700 font-semibold text-ellipsis line-clamp-2'>
              {projectName}
            </div>
            <span className='text-sm text-gray-500'>
              {DisplayDataForRoleType[projectType].label}
            </span>
          </div>
        </div>
      </div>
      <div className='flex flex-wrap gap-2'>
        {tags.map((tag) => (
          <PillBadge key={`tag-${tag}`} variant='plain' color='gray' size='lg'>
            {tag}
          </PillBadge>
        ))}
      </div>
      <div className='border-t border-gray-100 -mx-4 pt-4 px-6 pb-0'>
        <div className='sm:hidden ml-auto w-full'>
          <Button variant='secondary-gray' size='lg' href={`/projects/${projectId}`}>
            View project
          </Button>
        </div>
        <div className='hidden sm:block ml-auto w-fit'>
          <Button variant='secondary-gray' size='sm' href={`/projects/${projectId}`}>
            View project
          </Button>
        </div>
      </div>
    </div>
  );
};
